import React from 'react';
import { useTranslation } from 'react-i18next';

import s from './Integrations.module.css';

const SetupIIKO = () => {
  const [t] = useTranslation();

  const LINK = 'https://loyal-up.com/docs/iiko';

  return (
    <>
      <h2 className={s.title}>{t('Подключение iikoFront')}</h2>
      <p className={s.description}>
        {t(
          'Мы разработали интеграционный плагин, который обеспечивает работу карт лояльности на базе процессинга Loyal UP, где происходит обработка всех операций.',
        )}
      </p>
      <p className={s.description}>
        {t('Это позволит вам настраивать такие программы лояльности как')}:
        <ul>
          <li>{t('Скидки по фиксированным процентам')}</li>
          <li>{t('Начисление и списание бонусов в счет скидки на следующий заказ')}</li>
          <li>{t('Начисление приветственных бонусов для новых клиентов и бонусов в день рождения')}</li>
        </ul>
      </p>
      <p className={s.description}>
        {t('Для получения плагина и ключей к нему обратитесь к вашему менеджеру или в чат техподдержки.')}
      </p>
      <p className={s.description}>
        {t('Передайте документацию для интеграции своим техническим специалистам.')}
        &nbsp;
        {t('Документация доступна по ссылке')}
        :&nbsp;
        <a href={LINK} target="_blank" rel="noopener noreferrer">
          {LINK}
        </a>
        .
      </p>
      <p className={s.description}>
        {t('По всем интересующим вопросам обращайтесь к нам на почту')}
        &nbsp;
        <a href="mailto:support@loyal-up.com">support@loyal-up.com</a>.
      </p>
    </>
  );
};

export default SetupIIKO;
